module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('tickets-table', {
    attrs: {
      "site-id": _vm.rowData.id,
      "read-only": _vm.readOnly,
      "hide-site": true,
      "show-owner": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d061750"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteMaint.vue
// module id = 1590
// module chunks = 0